import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileFamilyReplyReceiveMessageState {
  /** 本文 */
  text: string;
  /** 添付ファイル */
  files: Array<File>;
  /** 関係 */
  familyRelation: string;
  /** 役割 */
  familyPosition: string;
  /** 受信者 */
  receiver: string;
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### mobileFamilyReplyReceiveMessage store
 *
 * - store
 *   - 新規送信画面の入力情報を保持する
 * - action, mutation
 *   - 新規送信画面の入力情報を格納する
 */
@Module({ name: "mobileFamilyReplyReceiveMessage" })
export default class mobileFamilyReplyReceiveMessage extends VuexModule implements MobileFamilyReplyReceiveMessageState {
  text = "";
  files = [];
  familyRelation = "";
  familyPosition = "";
  receiver = "";
  exist = false;

  /** stateのgetters */
  get mobileFamilyReplyReceiveMessageState(): MobileFamilyReplyReceiveMessageState {
    const state: MobileFamilyReplyReceiveMessageState = {
      text: this.text,
      files: this.files,
      familyRelation: this.familyRelation,
      familyPosition: this.familyPosition,
      receiver: this.receiver,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILE_FAMILY_REPLY_RECEIVE_MESSAGE_STATE(state: MobileFamilyReplyReceiveMessageState) {
    this.text = state.text;
    this.files = state.files as never[];
    this.familyRelation = state.familyRelation;
    this.familyPosition = state.familyPosition;
    this.receiver = state.receiver;
    this.exist = true;
    return;
  }

  @Mutation
  private RESET_MOBILE_FAMILY_REPLY_RECEIVE_MESSAGE_STATE() {
    this.text = "";
    this.files = [];
    this.familyRelation = "";
    this.familyPosition = "";
    this.receiver = "";
    this.exist = false;
    return;
  }

  /**
   * ### 受信メッセージの返信画面の入力情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileFamilyReplyReceiveMessage(payload: { state: MobileFamilyReplyReceiveMessageState }): void {
    this.SET_MOBILE_FAMILY_REPLY_RECEIVE_MESSAGE_STATE(payload.state);
    return;
  }

  /**
   * ### 受信メッセージの返信画面の入力情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileFamilyReplyReceiveMessage(): void {
    this.RESET_MOBILE_FAMILY_REPLY_RECEIVE_MESSAGE_STATE();
    return;
  }
}
